/** @jsxImportSource @emotion/react */
'use memo'

import colors from '@sportninja/common/constants/appColors'

type HeaderCancelIconProps = {
  color?: string
  size?: number
}

const HeaderCancelIcon = ({
  color = colors.WHITE,
  size = 24,
}: HeaderCancelIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      aria-hidden='true'
    >
      <path
        d='M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z'
        fill={color}
      />
    </svg>
  )
}

export default HeaderCancelIcon
